module.exports = __webpack_public_path__ + "img/screen-participants-en.11a2489a.png";